import { useUserData } from 'app/main/components';
import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabProps, ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import UsersListItem from '../UsersListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => (
			<ViewPageListTab
				{...props}
				id="usersView"
				itemLayout={UsersListItem}
				filters={[{ filt_field: 'user_enabled', filt_clause: 'equals', filt_value: 1 }]}
			/>
		)
	}
];

export default tabs;
